<template>
  <div class="loading-wrapper">
    <ve-progress :progress="100" :size="100" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from 'vue-facing-decorator';

@Component
class Loading extends Vue {}
export default toNative(Loading);
export { Loading };
</script>

<style scoped>
.loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.8;
  z-index: 10000;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 画面全体の中央に配置する場合 */
}
</style>
